export default "__VITE_ASSET__yFe4RXD9__"